<template>
    <section>
            <v-layout row style="border-bottom: 1px solid lightgray;">
            <v-layout xs6 style="border-right: 1px solid lightgray;" row>
                <v-flex style="font-size: 18px;padding: 20px 8px 0px;text-align: center;font-weight: bold;width: 100px;">Filter :</v-flex>
                <v-radio-group style="margin: 5px;padding-top: 10px;" v-model="Support_Type" row @change="GetDataNextFromDB">
                    <v-radio label="All" value="All"></v-radio>
                    <v-radio label="Technical" value="Technical"></v-radio>
                    <v-radio label="Non Technical" value="Non_Technical"></v-radio>
                    <v-radio label="General Discussion" value="General_Discussion"></v-radio>
                    <v-radio label="Open Tickets" value="Open"></v-radio>
                    <v-radio label="Closed Tickets" value="Closed"></v-radio>
                </v-radio-group>
            </v-layout>
            <v-layout xs6 style="padding: 0px 6px;border-right: 1px solid lightgrey;" row>
                <v-flex>
                    <v-menu v-model="menu1"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            full-width
                            min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field v-model="From_Date"
                                            label="Pick From Date"
                                            clearable
                                            prepend-icon="event"
                                            readonly
                                            v-on="on"></v-text-field>
                            </template>
                            <v-date-picker v-model="From_Date" @input="menu1 = false"></v-date-picker>
                </v-menu>
                </v-flex>
                <v-flex>
                     <v-menu v-model="menu2"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            full-width
                            min-width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field v-model="To_Date"
                                        label="Pick To date"
                                        prepend-icon="event"
                                        clearable
                                        readonly
                                        v-on="on"></v-text-field>
                        </template>
                        <v-date-picker v-model="To_Date" @input="menu2 = false"></v-date-picker>
                    </v-menu>
                </v-flex>
                <v-btn icon style="margin: 0px 14px;margin-top: 13px;">
                    <v-icon @click="SearchNow">search</v-icon>
                </v-btn>
            </v-layout>
        </v-layout>
        <v-data-table :headers="headers" 
                        :items="Tickets" 
                        item-key="Course_Title"
                        hide-actions
                        class="elevation-1" 
                        style="margin-bottom: 10px;"
                        disable-initial-sort>
            <template v-slot:headers="props">
                <tr>
                    <th v-for="header in props.headers" :key="header.text">
                        {{ header.text }}
                    </th>
                </tr>
            </template>
            <template v-slot:items="props">
                <tr>
                    <td class="text-xs-center">{{ props.item.Ticket_Id  }}</td>
                    <td class="text-xs-center">{{ props.item.Ticket_Status ? "Open" : "Closed"  }}</td>
                    <td class="text-xs-center">{{ props.item.Course_Title ? props.item.Course_Title : props.item.Project_Title  }}</td>
                    <td class="text-xs-center">{{ props.item.Email  }}</td>
                    <td class="text-xs-center">{{ props.item.Support_Type  }}</td>
                    <td class="text-xs-center">{{ props.item.Question  }}</td>
                    <td class="text-xs-center">{{ new Date(props.item.Created_On).toLocaleDateString()  }}</td>
                    <td class="text-xs-center">
                        <v-btn color="primary" icon class="btnAction" @click="OpenToUpdate(props.item)">
                            <v-icon>edit</v-icon>
                        </v-btn>
                    </td>
                </tr>
            </template>
        </v-data-table>
        <pagination v-model="pages" :records="Records" :per-page="10" @paginate="GetDataNextFromDB"></pagination>
    </section>
</template>
<script>

export default {
    data(){

        return {

            headers  : [ { text: 'Ticket Id', value: 'Ticket_Id' },
                         { text: 'Status', value: 'Status' },
                         { text: 'Title' },
                         { text: 'Email', value: 'Email' },
                         { text: 'Support Type', value: 'Support_Type' },
                         { text: 'Question', value: 'Question' },
                         { text: 'Created On', value: 'Created_On' },
                         { text: 'Reply' }],
            Tickets     : [],
            pages       : 1,
            Records     : 0,
            Support_Type  : "All",
            loading     : false,
            From_Date   : null,
            To_Date     : null,
            menu1       : false,
            menu2       : false,
        }
    },
    computed:{
        GetCourseList(){

            return this.$store.getters.GetCourseDetailsList
        }
    },
    methods:{

        SearchNow(){

            this.loading = true
            let data = { 'limit' : 10, 'page' : this.pages }
            if(this.Support_Type != 'All'){

                this.Support_Type == 'Open' || this.Support_Type == 'Closed' ? data['Ticket_Status'] = this.Support_Type == 'Open' ? 'true' : 'false'  : ""
                this.Support_Type && this.Support_Type != 'Open' && this.Support_Type != 'Closed' ? data['Support_Type'] = this.Support_Type : ""
                this.From_Date ? data['From_Date']   = new Date(this.From_Date).setHours(0,0,0,0) : ""
                this.To_Date ? data['To_Date']       = new Date(this.To_Date).setHours(23,59,59,59) : ""
                this.GetDataFromDB(data)

            }else{

                this.From_Date ? data['From_Date']   = new Date(this.From_Date).setHours(0,0,0,0) : ""
                this.To_Date ? data['To_Date']       = new Date(this.To_Date).setHours(23,59,59,59) : ""
                this.GetDataFromDB(data)
            }
        },
        OpenToUpdate(data){

            this.$emit('UPDATE',data)
        },
        GetDataFromDB(data){
            
            this.$http.post(`${this.$store.getters.GetProductionUrl}/support/gettickets`,data)
                    .then(response =>{
                        
                        this.Tickets = response['data']['response']
                        this.Records = response['data']['Records']

                    })
                    .catch(err =>{

                        this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Fetching Data","Color":"red","Close": false });
                    })
        },
        UpdateTable(data){
            
            this.Tickets = data['response']
            this.Records = data['Records']
        },
        GetDataNextFromDB(){

            this.loading = true
            let data = { 'limit' : 10, 'page' : this.pages }
            if(this.Support_Type != 'All'){

                this.Support_Type == 'Open' || this.Support_Type == 'Closed' ? data['Ticket_Status'] = this.Support_Type == 'Open' ? 'true' : 'false'  : ""
                this.Support_Type && this.Support_Type != 'Open' && this.Support_Type != 'Closed' ? data['Support_Type'] = this.Support_Type : ""
                this.From_Date ? data['From_Date']   = new Date(this.From_Date).setHours(0,0,0,0) : ""
                this.To_Date ? data['To_Date']       = new Date(this.To_Date).setHours(23,59,59,59) : ""
                this.GetDataFromDB(data)

            }else{

                this.GetDataFromDB(data)
            }   
        }
    },
    mounted(){

        this.GetDataFromDB({ limit:10, page : this.pages })
        
    }
}
</script>
<style>
.VuePagination ul{
    display: -ms-flexbox;
    display: -webkit-box;
    display: flex;
    padding-left: 0;
    list-style: none;
    border-radius: 0.25rem;
 }
.VuePagination li{
    border: 1px solid #887a7a0f !important;
 }
 .pagination {
    display: -ms-flexbox;
    display: -webkit-box;
    display: flex;
    padding-left: 0;
    list-style: none;
    border-radius: 0.25rem;
}
.page-link {
    position: relative;
    display: block;
    padding: 0.5rem 0.75rem;
    margin-left: -1px;
    line-height: 1.25;
    color: #007bff;
    background-color: #fff;
    border: 1px solid #dee2e6;
    text-decoration: none;
}
.VuePagination__count {
    font-size: 12px;
    font-weight: bold;
    text-align: right;
    text-transform: capitalize;
}
.clsForActions{
    margin: 2px;
    padding: 2px;
    border: 1px solid #0000003d;
    border-radius: 2px;
    cursor: pointer;
}
</style>


